module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/4@2x_3553fda1fdaeb66a98a7409e1e5897f6.png";